import React from 'react';

const TableHeader = ({ children, title }) => (
  <div>
    <span
      className="box-headingText highcharts-root"
      style={{ marginBottom: '10px', marginTop: '5px' }}
    >
      {title}
    </span>
    {children}
  </div>
);
export default TableHeader;
